import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeService {

  constructor() { }

  now() {
    return Math.round(new Date().getTime() / 1000.0);
  }
}
